import { Navigate, useRoutes } from "react-router-dom";
// auth
import AuthGuard from "../auth/AuthGuard";
import GuestGuard from "../auth/GuestGuard";
// layouts
import CompactLayout from "../layouts/compact";
import DashboardLayout from "../layouts/dashboard";
import GuestLayout from "../layouts/Guest";
// config
import { PATH_AFTER_LOGIN } from "../config";
//
import {
  Page404,
  PageSix,
  PageFour,
  PageFive,
  LoginPage,
  LoginVerifyPage,
  ResetPassword,
  Dashboard,
  AllBusinesses,
  OnboardingRequests,
  BusinessConnections,
  SetNewPassword,
  OnboardingRequestView,
  Invoices,
  Accounting,
  Billing,
  AdminControl,
  AssuredPayFee,
  Activity,
  Chat,
  BankLogs,
  TicketManagement,
  TicketDetail,
  Affiliate,
  Tier,
  Settlement,
  AffiliateAnalytics,
  // Sales Components
  SalesDashboard,
  SalesUsersList,
  AddSalesUser,
  EditSalesUser,
  ViewSalesUser,
  IncentiveRules,
  AddIncentivePlan,
  EditIncentivePlan,
  SalesSettlement,
  BusinessView,
  AffiliatesInvited,
} from "./elements";

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    {
      path: "/",
      element: (
        <GuestGuard>
          <GuestLayout />
        </GuestGuard>
      ),
      children: [
        { element: <Navigate to={"/login"} replace />, index: true },
        { path: "login", element: <LoginPage /> },
        { path: "login-verify", element: <LoginVerifyPage /> },
        { path: "reset-password", element: <ResetPassword /> },
        { path: "set-new-password", element: <SetNewPassword /> },
        // { path: "sign-up", element: <SignUpPage /> },
        // { path: "sign-up-mobile-verify", element: <SignUpMobileVerify /> },
        // { path: "sign-up-email-verify", element: <SignUpEmailVerify /> },
      ],
    },

    {
      path: "/auth",
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
        { path: "dashboard", element: <Dashboard /> },
        {
          path: "business-management",
          children: [
            {
              element: (
                <Navigate to={"/auth/business-management/business"} replace />
              ),
              index: true,
            },
            {
              path: "business",
              children: [
                {
                  element: (
                    <Navigate
                      to={"/auth/business-management/business/list"}
                      replace
                    />
                  ),
                  index: true,
                },
                { path: "list", element: <AllBusinesses /> },
                { path: "view/:id", element: <BusinessView /> },
              ],
            },
            {
              path: "requests",
              children: [
                {
                  element: (
                    <Navigate
                      to={"/auth/business-management/requests/list"}
                      replace
                    />
                  ),
                  index: true,
                },
                { path: "list", element: <OnboardingRequests /> },
                { path: "view/:id", element: <OnboardingRequestView /> },
              ],
            },
            { path: "connections", element: <BusinessConnections /> },
          ],
        },
        { path: "invoices", element: <Invoices /> },
        { path: "accounting", element: <Accounting /> },
        { path: "billing", element: <Billing /> },
        { path: "fee", element: <AssuredPayFee /> },
        { path: "activity", element: <Activity /> },
        { path: "AdminControl", element: <AdminControl /> },
        { path: "BankLogs", element: <BankLogs /> },
        { path: "Chat/:id", element: <Chat /> },
        {
          path: "TicketManagement",
          children: [
            {
              element: <Navigate to={"/auth/TicketManagement/list"} replace />,
              index: true,
            },
            { path: "list", element: <TicketManagement /> },
            { path: "view/:id", element: <TicketDetail /> },
          ],
        },
        {
          path: "sales",
          children: [
            {
              element: <Navigate to="/auth/sales/dashboard" replace />,
              index: true,
            },
            { path: "dashboard", element: <SalesDashboard /> },
            { path: "users", element: <SalesUsersList /> },
            { path: "users/add", element: <AddSalesUser /> },
            { path: "users/view/:id", element: <ViewSalesUser /> },
            { path: "users/edit/:id", element: <EditSalesUser /> },
            { path: "incentive-plan", element: <IncentiveRules /> },
            { path: "incentive-plan/add", element: <AddIncentivePlan /> },
            { path: "incentive-plan/edit/:id", element: <EditIncentivePlan /> },
            { path: "settlement", element: <SalesSettlement /> },
          ],
        },
        {
          path: "affiliate",
          children: [
            {
              element: <Navigate to={"/auth/affiliate/list"} replace />,
              index: true,
            },
            { path: "AffiliateAnalytics", element: <AffiliateAnalytics /> },
            { path: "list", element: <Affiliate /> },
            { path: "tier", element: <Tier /> },
            { path: "Settlement", element: <Settlement /> },
            { path: "AffiliatesInvited/:id", element: <AffiliatesInvited /> },
          ],
        },
      ],
    },
    {
      element: <CompactLayout />,
      children: [{ path: "404", element: <Page404 /> }],
    },
    { path: "*", element: <Navigate to="/404" replace /> },
  ]);
}
